import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    awaitingBeneficiariesTitle: 'Application overview of company {companyName}',

    beneficiariesMailInfo: {
      mandatee:
        'Please check with your clients to make sure they received our registration email.',
      nonMandatee:
        'Please check with your company’s key individuals to make sure they received our registration email.',
    },
    beneficiaryWaitingText: {
      mandatee:
        'Ensure that all legal beneficiaries of the company have completed their information. We need it to finalize the creation of the account.',
      nonMandatee:
        'Ensure that all the key individuals of your company have completed their information. We need it to finalize the creation of your account.',
    },
    beneficiaryWaitingTitle: {
      mandatee: 'To be completed by legal beneficiaries',
      nonMandatee: 'To be completed by your company’s key individuals',
    },
    companyCreationDescription:
      'Receive your deposit certificate and finalize your company creation.',
    companyCreationSentByMail:
      'We sent you your certificate and all the information by email at **{email}**.',
    companyCreationTitle: 'Company creation',
    documentsReviewedDescription:
      'We’re reviewing your documents.\nThis usually takes 48 hours.',
    fundsDepositDescription:
      'Transfer your capital amount to receive your certificate of deposit.',
    fundsDepositSentByMail:
      'We sent you all the information by email at **{email}**.',
    fundsDepositTitle: 'Funds deposit',
    legalVerificationSentByMail:
      'We sent you all the information by email at **{email}**.',
    legalVerificationTitle: 'Legal verification',
    title: 'Your capital deposit',
  },
  fr: {
    awaitingBeneficiariesTitle:
      'Suivi du dossier de l’entreprise {companyName}',
    beneficiariesMailInfo: {
      mandatee:
        'Vérifiez bien auprès de votre client•e, la bonne réception de notre email d’inscription.',
      nonMandatee:
        'Vérifiez bien auprès des personnes clés de l’entreprise, la bonne réception de notre email d’inscription.',
    },
    beneficiaryWaitingText: {
      mandatee:
        'Les bénéficiaires effectifs et tous les actionnaires doivent renseigner leurs informations pour que nous puissions **valider le dossier**',
      nonMandatee:
        'Les personnes clés de l’entreprise doivent renseigner leurs informations pour que nous puissions **valider le dossier**',
    },
    beneficiaryWaitingTitle: {
      mandatee: 'À compléter par les bénéficiaires effectifs',
      nonMandatee: 'À compléter par les personnes clés',
    },
    companyCreationDescription:
      'Récupérez votre certificat de dépôt et finalisez la création de votre entreprise.',
    companyCreationSentByMail:
      'Nous vous avons envoyé votre certificat et toutes les informations complémentaires par mail à **{email}**.',
    companyCreationTitle: 'Création de votre entreprise',
    documentsReviewedDescription:
      'Nous vérifions vos documents. Cela prend en général 48 heures.',
    fundsDepositDescription:
      'Effectuez votre dépôt de capital afin de recevoir votre certificat de dépôt.',
    fundsDepositSentByMail:
      'Nous vous avons envoyé toutes les informations par mail à **{email}**.',
    fundsDepositTitle: 'Dépôt des fonds',
    legalVerificationSentByMail:
      'Nous vous avons envoyé toutes les informations par mail à **{email}**.',
    legalVerificationTitle: 'Vérification du dossier',
    title: 'Votre dépôt de capital',
  },
} as const);

export default locales;
